import { RebateCode } from "@/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

type InitialState = {
  status: BuyStatus;
  entity?: RebateCode;
};

enum BuyStatus {
  Idle,
  Pending,
  Done,
}

type BuyRebateCodeArgs = {
  rebateCode: RebateCode;
};

export const buyRebateCode = createAsyncThunk(
  "/rebatecode/buy",
  async ({ rebateCode }: BuyRebateCodeArgs, thunkApi) => {
    try {
      if (!rebateCode?.Id) {
        throw new Error("Missing rebate code id.");
      }

      window.location.hash = `/payment/rebate/${rebateCode.Id}`;
      return thunkApi.fulfillWithValue(rebateCode);
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

const initialState: InitialState = {
  status: BuyStatus.Idle,
};

const rebateCodeSlice = createSlice({
  name: "rebateCode",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(buyRebateCode.pending, (state, action) => {
      state.status = BuyStatus.Pending;
      state.entity = action.meta.arg.rebateCode;
    });

    builder.addCase(buyRebateCode.rejected, (state) => {
      state.status = BuyStatus.Idle;
      state.entity = undefined;
    });

    builder.addCase(buyRebateCode.fulfilled, (state) => {
      state.status = BuyStatus.Done;
      state.entity = undefined;
    });
  },
});

export default rebateCodeSlice;
